module.exports = __webpack_public_path__ + "static/media/hand1.035929c0.bin";